module.exports = __webpack_public_path__ + "static/media/duplex_orange.813aeb28.svg";